import CommonSearch from './CommonSearch';

export default function FacilitySearch({
  onSearchChanged,
}: Readonly<{
  onSearchChanged: (searchText?: string, entityType?: string) => void;
}>) {
  return (
    <CommonSearch
      title="Search Facility"
      entityType="facility"
      onSearchChanged={onSearchChanged}
    />
  );
}
